import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useFormik } from 'formik'

import { uiGlobalSelector } from '@/state/ui/global/slices/index.slices'
import {
  BonusTriggerType,
  BonusType,
  ManualWalletAssign,
  FormStatusType,
  RolloverTypeEnum,
} from '@/enums'
import useBonusEngineFormActions from '@/views/bonus-engine-form/hooks/use-be-offers-actions.hook'

import keys from '@/utils/keys'
import { ApplicationState } from '@/state/root.models'
import { removeEmptyProp } from '@/utils'

import { useWalletsActions, useWalletsSchema, ProviderValue } from './'

export const useWalletsForm = () => {
  const { setManualBonus, getAllBonuses } = useWalletsActions()

  const { REACT_APP_STAGE: env } = process.env

  const { getAllProvidersAction } = useBonusEngineFormActions()

  const { formMode, dialog } = useSelector(uiGlobalSelector)

  const { loggedUser } = useSelector(({ auth }: ApplicationState) => auth)

  const { validationSchemaManualWallet, initialValuesManualWallet } =
    useWalletsSchema()

  const [filterBonusTrigger, setBonusTrigger] =
    useState<{ index: BonusTriggerType; label: string }[]>()

  const formikManualWallet = useFormik({
    initialValues: initialValuesManualWallet,
    validationSchema: validationSchemaManualWallet,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  const buildPayloadByTrigger = () => {
    const {
      playerId,
      bonusCode,
      bonusType,
      depositAmount,
      depositId,
      comment,
      bonusAmount,
      rollover,
      providers,
      maxWin,
      username,
      byPlayer,
      bonusTrigger,
      rolloverType,
    } = formikManualWallet.values

    const newProviders =
      providers.length > 0
        ? providers.map((item: ProviderValue) => {
            const provider = {
              provider: item.value,
            }
            return provider
          })
        : []

    switch (bonusTrigger) {
      case BonusTriggerType.DEPOSIT_BY_CLICK:
      case BonusTriggerType.DEPOSIT_BY_CODE:
        return {
          bonusType: Number(bonusType),
          bonusCode: bonusCode.code,
          depositAmount: depositAmount,
          depositId: depositId,
          // playerId:
          //   byPlayer === ManualWalletAssign.PLAYER ? playerId : undefined,
          // username:
          //   byPlayer === ManualWalletAssign.USERNAME ? username : undefined,
          playerId: playerId,
          username: username,
          providers: [...newProviders],
        }

      case BonusTriggerType.BY_CODE:
        return {
          bonusType: Number(bonusType),
          bonusCode: bonusCode.code,
          // HERE
          // playerId:
          //   byPlayer === ManualWalletAssign.PLAYER ? playerId : undefined,
          // username:
          //   byPlayer === ManualWalletAssign.USERNAME ? username : undefined,
          playerId: playerId,
          username: username,
        }

      case BonusTriggerType.GAMIFICATION:
      case BonusTriggerType.BY_REGISTRATION:
        return {
          bonusType: Number(bonusType),
          bonusCode: bonusCode.code,
          // playerId:
          //   byPlayer === ManualWalletAssign.PLAYER ? playerId : undefined,
          // username:
          //   byPlayer === ManualWalletAssign.USERNAME ? username : undefined,
          playerId: playerId,
          username: username,
          providers: [...newProviders],
        }

      default:
        // BonusTriggerType.MANUAL
        return {
          bonusType: Number(bonusType),
          bonusAmount: bonusAmount,
          rollover:
            rolloverType === RolloverTypeEnum.COEFFICIENT
              ? `${Number(rollover) * Number(bonusAmount)}`
              : rollover,
          comment: comment || '',
          // playerId:
          //   byPlayer === ManualWalletAssign.PLAYER ? playerId : undefined,
          // username:
          //   byPlayer === ManualWalletAssign.USERNAME ? username : undefined,
          playerId: playerId,
          username: username,
          providers: [...newProviders],
          maxWin: maxWin,
        }
    }
  }

  const handleOnSubmit = () => {
    if (formMode === FormStatusType.CREATE) {
      setManualBonus({
        ...removeEmptyProp(buildPayloadByTrigger()),
        assignedBy: loggedUser.username,
      })
    }
  }

  const handleResetForm = () => {
    formikManualWallet.resetForm()
  }

  const bonusTriggerTypes = [
    ...keys(BonusTriggerType)
      .filter(
        (item) =>
          typeof BonusTriggerType[item] !== 'string' &&
          (BonusTriggerType[item] === BonusTriggerType.DEPOSIT_BY_CLICK ||
            BonusTriggerType[item] === BonusTriggerType.GAMIFICATION ||
            BonusTriggerType[item] === BonusTriggerType.MANUAL ||
            BonusTriggerType[item] === BonusTriggerType.BY_REGISTRATION ||
            BonusTriggerType[item] === BonusTriggerType.BY_CODE),
      )
      .map((x) => {
        return {
          index: BonusTriggerType[x],
          label:
            x === 'DEPOSIT_BY_CLICK'
              ? 'DEPOSIT'
              : x === 'MANUAL'
                ? 'MANUAL'
                : x,
        }
      }),
  ].sort((a, b) => a.label.localeCompare(b.label))

  const EXCLUDED_BONUS = ['BETSOFT_CASINO']
  const INCLUDED_BONUS = ['CASINO_STANDARD', 'FREE_SPINS']

  const bonusType = [
    ...keys(BonusType)
      .filter(
        (item) =>
          typeof BonusType[item] !== 'number' &&
          !EXCLUDED_BONUS.includes(item) &&
          (env === 'prod' || env === 'stg') &&
          INCLUDED_BONUS.includes(item),
      )
      .map((x) => ({
        index: BonusType[x],
        label: x,
      })),
  ].sort((a, b) => a.label.localeCompare(b.label))

  // const bonusType = [
  //   ...keys(BonusType)
  //     .filter(
  //       (item) =>
  //         typeof BonusType[item] !== 'number' &&
  //         ((env === 'prod' &&
  //           (item === 'CASINO_STANDARD' ||
  //             item === 'FREE_SPINS' ||
  //             // item === 'FREE_PLAY' ||
  //             item === 'BETSOFT_CASINO')) ||
  //           (env === 'stg' &&
  //             (item === 'CASINO_STANDARD' ||
  //               item === 'FREE_SPINS' ||
  //               // item === 'FREE_PLAY' ||
  //               item === 'BETSOFT_CASINO'))),
  //     )
  //     .map((x) => {
  //       return {
  //         index: BonusType[x],
  //         label: x,
  //       }
  //     }),
  // ].sort((a, b) => a.label.localeCompare(b.label))

  const handleFilterBonusTrigger = () => {
    const isFreeSpins =
      formikManualWallet.values.bonusType?.toString() === BonusType.FREE_SPINS

    setBonusTrigger(
      isFreeSpins
        ? bonusTriggerTypes.filter(
            (item) => item.index !== BonusTriggerType.MANUAL,
          )
        : bonusTriggerTypes,
    )
  }
  //   const handleFilterBonusTrigger = () => {
  //   let triggers = []
  //   if (
  //     formikManualWallet.values.bonusType.toString() ===
  //     BonusType.CASINO_STANDARD
  //   ) {
  //     triggers = bonusTriggerTypes.filter(
  //       (item) =>
  //         (env === 'prod' &&
  //           item.index !== BonusTriggerType.GAMIFICATION &&
  //           item.index !== BonusTriggerType.BY_REGISTRATION &&
  //           item.index !== BonusTriggerType.BY_BUNDLE &&
  //           item.index !== BonusTriggerType.BY_CODE) ||
  //         (env === 'stg' && item.index !== BonusTriggerType.BY_BUNDLE),
  //     )
  //   } else if (
  //     formikManualWallet.values.bonusType.toString() ===
  //     BonusType.BETSOFT_CASINO
  //   ) {
  //     triggers = bonusTriggerTypes.filter(
  //       (item) =>
  //         (env === 'prod' &&
  //           item.index !== BonusTriggerType.GAMIFICATION &&
  //           item.index !== BonusTriggerType.BY_REGISTRATION &&
  //           item.index !== BonusTriggerType.BY_BUNDLE &&
  //           item.index !== BonusTriggerType.BY_CODE &&
  //           item.index !== BonusTriggerType.MANUAL) ||
  //         (env === 'stg' &&
  //           item.index !== BonusTriggerType.BY_BUNDLE &&
  //           item.index !== BonusTriggerType.MANUAL),
  //     )
  //   } else {
  //     triggers = bonusTriggerTypes.filter(
  //       (item) =>
  //         (env === 'stg' &&
  //           item.index !== BonusTriggerType.MANUAL &&
  //           item.index !== BonusTriggerType.BY_BUNDLE) ||
  //         (env === 'prod' &&
  //           item.index !== BonusTriggerType.GAMIFICATION &&
  //           item.index !== BonusTriggerType.BY_REGISTRATION &&
  //           item.index !== BonusTriggerType.MANUAL &&
  //           item.index !== BonusTriggerType.BY_BUNDLE &&
  //           item.index !== BonusTriggerType.BY_CODE),
  //     )
  //   }

  //   setBonusTrigger(triggers)
  // }

  useEffect(() => {
    getAllProvidersAction({ category: 4 })
  }, []) // eslint-disable-line

  useEffect(() => {
    if (dialog.open) {
      getAllBonuses({
        limit: 9999,
        page: 1,
        isActive: 1,
        triggerBy: formikManualWallet.values.bonusTrigger
          ? formikManualWallet.values.bonusTrigger.toString()
          : '',
        bonusType: formikManualWallet.values.bonusType,
      })

      formikManualWallet.setFieldValue('bonusTrigger', '')
    }
    handleFilterBonusTrigger()
  }, [formikManualWallet.values.bonusType]) // eslint-disable-line

  useEffect(() => {
    if (
      formikManualWallet.values.bonusTrigger ===
        BonusTriggerType.GAMIFICATION ||
      formikManualWallet.values.bonusTrigger ===
        BonusTriggerType.BY_REGISTRATION ||
      formikManualWallet.values.bonusTrigger === BonusTriggerType.BY_CODE
    ) {
      getAllBonuses({
        limit: 9999,
        page: 1,
        isActive: 1,
        triggerBy: formikManualWallet.values.bonusTrigger.toString(),
        bonusType: formikManualWallet.values.bonusType,
      })
    } else if (
      formikManualWallet.values.bonusTrigger ===
        BonusTriggerType.DEPOSIT_BY_CLICK ||
      formikManualWallet.values.bonusTrigger ===
        BonusTriggerType.DEPOSIT_BY_CODE ||
      formikManualWallet.values.bonusTrigger === BonusTriggerType.MANUAL
    ) {
      getAllBonuses({
        limit: 9999,
        page: 1,
        isActive: 1,
        triggerBy: '-1',
        bonusType: formikManualWallet.values.bonusType,
      })
    }

    formikManualWallet.setFieldValue('bonusCode', '')
    formikManualWallet.setFieldValue('providers', [])
  }, [formikManualWallet.values.bonusTrigger]) // eslint-disable-line

  return {
    formikManualWallet,
    bonusTriggerTypes: filterBonusTrigger,
    bonusType,
    handleResetForm,
    handleOnSubmit,
  }
}
